module.exports = __webpack_public_path__ + "img/cir1.cb7d2f9c.png";